
export class Auth {

  tokenId: string = null;
  avatar: string = null;
  firstName: string = null;
  lastName: string = null;
  email: string = null;

  constructor(
    public projectId: string
  ) {}

}

